module.exports = __webpack_public_path__ + "img/icon4.eef719b9.png";